var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-box"},[_c('title1',{attrs:{"type":"1","title":"最新告警列表信息"}}),_c('div',{staticClass:"box-1",staticStyle:{"height":"360px"}},[_c('dv-scroll-board',{staticClass:"newTable",attrs:{"config":_vm.config}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }